import { render } from "./XIconSolidWallet.vue?vue&type=template&id=492dcbed"
import script from "./XIconSolidWallet.vue?vue&type=script&lang=js"
export * from "./XIconSolidWallet.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidWallet.vue"]])

export default __exports__